// components/navbar/ResponsiveNavbar.js
import React, { useState, useEffect } from 'react';
import DesktopNavbar from './DesktopNavbar';
import MobileNavbar from './MobileNavbar';
import './styles/Navbar.css';

const ResponsiveNavbar = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  
  // Update viewport check on resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };
    
    // Add event listener for window resize
    window.addEventListener('resize', handleResize);
    
    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Render the appropriate navbar based on viewport size
  return isMobile ? <MobileNavbar /> : <DesktopNavbar />;
};

export default ResponsiveNavbar;